export default [
    {
        "id": "6459359243",
        "title": "GIS esiseinapaigaldis massiivse vaheseina ees",
        "wandtypen": [
            "6451212427",
            "6451213579",
            "6451220491",
            "6451239051"
        ],
        "produktfamile": [
            "4948020619"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "filenameWithoutExtension": "6453031691__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit GIS* esiseinapaigaldis massiivse vaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 28,
        "LAF_DIN_diagonalDarunterliegenderRaum": 18,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 33,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 26,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 21,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 16
    },
    {
        "id": "6459385355",
        "title": "GIS esiseinapaigaldis kipsseina ees",
        "wandtypen": [
            "6451220491",
            "6451221643"
        ],
        "produktfamile": [
            "4948020619"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "filenameWithoutExtension": "6465952907__et__Original",
        "imageTitle": " Katsestendi ehitus: Geberit GIS* esiseinapaigaldis kipsvaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 27,
        "LAF_DIN_diagonalDarunterliegenderRaum": 17,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 28,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 25,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 20,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 15
    },
    {
        "id": "6459346315",
        "title": "GIS ruumikõrgune vahesein",
        "wandtypen": [
            "6451245963"
        ],
        "produktfamile": [
            "4948020619"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "filenameWithoutExtension": "6465931147__et__Original",
        "imageTitle": " Katsestendi ehitus: Geberit GIS* ruumikõrgune vahesein",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 37,
        "LAF_DIN_diagonalDarunterliegenderRaum": 17,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 38,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 35,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 18,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 15
    },
    {
        "id": "6459354123",
        "title": "GIS esiseinapaigaldis Duofix süsteemiseina ees (ühekordne karkass)",
        "wandtypen": [
            "6451220491",
            "6451240203"
        ],
        "produktfamile": [
            "4948020619"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "filenameWithoutExtension": "6467012107__et__Original",
        "imageTitle": " Katsestendi ehitus: Geberit GIS esiseinapaigaldis Geberit Duofix süsteemiseina ees (ühekordne karkass)",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 33,
        "LAF_DIN_diagonalDarunterliegenderRaum": 23,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 33,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 31,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 21,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 21
    },
    {
        "id": "6459330699",
        "title": "Duofix süsteemi esiseinapaigaldis massiivse vaheseina ees",
        "wandtypen": [
            "6451219339",
            "6451239051"
        ],
        "produktfamile": [],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "filenameWithoutExtension": "6467190795__et__Original",
        "imageTitle": " Katsestendi ehitus: Geberit Duofix süsteemisein* esiseinana massiivse vaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 30,
        "LAF_DIN_diagonalDarunterliegenderRaum": 23,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 32,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 28,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 22,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 21
    },
    {
        "id": "6459338507",
        "title": "Duofix süsteemi esiseinapaigaldis kipsseina ees",
        "wandtypen": [
            "6451219339",
            "6451221643"
        ],
        "produktfamile": [],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "filenameWithoutExtension": "6469928971__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix süsteemisein* esiseinana kipsvaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 27,
        "LAF_DIN_diagonalDarunterliegenderRaum": 20,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 28,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 25,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 21,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 18
    },
    {
        "id": "6459320459",
        "title": "Duofix süsteem ruumikõrguse kipsvaheseinana",
        "wandtypen": [
            "6451244811"
        ],
        "produktfamile": [],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "filenameWithoutExtension": "6469261707__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix süsteemisein* ruumikõrguse kipsvaheseinana",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 28,
        "LAF_DIN_diagonalDarunterliegenderRaum": 17,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 28,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 26,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 17,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 15
    },
    {
        "id": "6459328267",
        "title": "Duofix süsteemi esiseinapaigaldis Duofix süsteemiseina ees",
        "wandtypen": [
            "6451219339",
            "6451240203"
        ],
        "produktfamile": [],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "filenameWithoutExtension": "6467329163__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix süsteemisein esiseinana Geberit Duofix süsteemisein ees (ühekordne karkass)",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 37,
        "LAF_DIN_diagonalDarunterliegenderRaum": 24,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 35,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 35,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 22,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 22
    },
    {
        "id": "6459312651",
        "title": "Duofix element kipsvaheseinas",
        "wandtypen": [
            "6452776331"
        ],
        "produktfamile": [
            "4948021771"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "filenameWithoutExtension": "6472442763__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix montaažielemendid ruumikõrguses kipsvaheseinas",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 28,
        "LAF_DIN_diagonalDarunterliegenderRaum": 21,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 29,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 26,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 19,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 19
    },
    {
        "id": "6459393163",
        "title": "Kombifix element massiivses esiseinas massiivse vaheseina ees",
        "wandtypen": [
            "6451218187",
            "6451239051"
        ],
        "produktfamile": [
            "4947988747"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "filenameWithoutExtension": "6472577931__et__Original",
        "imageTitle": "Geberit Kombifix montaažielement müüritud esiseinas massiivse vaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 38,
        "LAF_DIN_diagonalDarunterliegenderRaum": 27,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 40,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 36,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 30,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 25
    },
    {
        "id": "6459356555",
        "title": "GIS esiseinapaigaldis massiivse vaheseina ees",
        "wandtypen": [
            "6451220491",
            "6451239051"
        ],
        "produktfamile": [
            "4948020619"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6470756619__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit GIS* esiseinapaigaldis massiivse vaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 28,
        "LAF_DIN_diagonalDarunterliegenderRaum": 21,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 33,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 26,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 21,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 19
    },
    {
        "id": "6459387787",
        "title": "GIS esiseinapaigaldis kipsseina ees",
        "wandtypen": [
            "6451220491",
            "6451221643"
        ],
        "produktfamile": [
            "4948020619"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6470780299__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit GIS* esiseinapaigaldis kipsvaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 27,
        "LAF_DIN_diagonalDarunterliegenderRaum": 19,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 28,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 25,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 20,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 17
    },
    {
        "id": "6459348747",
        "title": "GIS ruumikõrgune vahesein",
        "wandtypen": [
            "6451245963"
        ],
        "produktfamile": [
            "4948020619"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6470844299__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit GIS* ruumikõrgune vahesein",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 37,
        "LAF_DIN_diagonalDarunterliegenderRaum": 21,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 38,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 35,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 19,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 19
    },
    {
        "id": "6459333131",
        "title": "Duofix süsteemi esiseinapaigaldis massiivse vaheseina ees",
        "wandtypen": [
            "6451219339",
            "6451239051"
        ],
        "produktfamile": [],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6470894475__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix süsteemisein* esiseinana massiivse vaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 30,
        "LAF_DIN_diagonalDarunterliegenderRaum": 26,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 32,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 28,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 24,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 24
    },
    {
        "id": "6459340939",
        "title": "Duofix süsteemi esiseinapaigaldis kipsseina ees",
        "wandtypen": [
            "6451219339",
            "6451221643"
        ],
        "produktfamile": [],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6470917003__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix süsteemisein* esiseinana kipsvaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 27,
        "LAF_DIN_diagonalDarunterliegenderRaum": 22,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 28,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 25,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 21,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 20
    },
    {
        "id": "6459322891",
        "title": "Duofix süsteem ruumikõrguse kipsvaheseinana",
        "wandtypen": [
            "6451244811"
        ],
        "produktfamile": [],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6470971659__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix süsteemisein* ruumikõrguse kipsvaheseinana",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 28,
        "LAF_DIN_diagonalDarunterliegenderRaum": 21,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 28,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 26,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 19,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 19
    },
    {
        "id": "6459315083",
        "title": "Duofix element kipsvaheseinas",
        "wandtypen": [
            "6452776331"
        ],
        "produktfamile": [
            "4948021771"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6472505739__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix montaažielemendid ruumikõrguses kipsvaheseinas",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 28,
        "LAF_DIN_diagonalDarunterliegenderRaum": 25,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 29,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 26,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 23,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 23
    },
    {
        "id": "6459395595",
        "title": "Kombifix element massiivses esiseinas massiivse vaheseina ees",
        "wandtypen": [
            "6451218187",
            "6451239051"
        ],
        "produktfamile": [
            "4947988747"
        ],
        "entWaesserungFallLeitung": [
            "Silent-db20",
            "Silent-Pro"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6472611723__et__Original",
        "imageTitle": "Geberit Kombifix montaažielement müüritud esiseinas massiivse vaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 38,
        "LAF_DIN_diagonalDarunterliegenderRaum": 30,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 40,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 36,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 30,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 28
    },
    {
        "id": "6459373707",
        "title": "GIS esiseinapaigaldis massiivse vaheseina ees",
        "wandtypen": [
            "6451220491",
            "6451239051"
        ],
        "produktfamile": [
            "4948020619"
        ],
        "entWaesserungFallLeitung": [
            "Silent-PP"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6471036427__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit GIS* esiseinapaigaldis massiivse vaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 28,
        "LAF_DIN_diagonalDarunterliegenderRaum": 24,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 33,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 26,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 22,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 22
    },
    {
        "id": "6459390475",
        "title": "GIS esiseinapaigaldis kipsseina ees",
        "wandtypen": [
            "6451220491",
            "6451221643"
        ],
        "produktfamile": [
            "4948020619"
        ],
        "entWaesserungFallLeitung": [
            "Silent-PP"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6471082507__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit GIS* esiseinapaigaldis kipsvaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 27,
        "LAF_DIN_diagonalDarunterliegenderRaum": 20,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 28,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 25,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 20,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 18
    },
    {
        "id": "6459351435",
        "title": "GIS ruumikõrgune vahesein",
        "wandtypen": [
            "6451245963"
        ],
        "produktfamile": [
            "4948020619"
        ],
        "entWaesserungFallLeitung": [
            "Silent-PP"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6471123851__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit GIS* ruumikõrgune vahesein",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 37,
        "LAF_DIN_diagonalDarunterliegenderRaum": 23,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 38,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 35,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 21,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 21
    },
    {
        "id": "6459335819",
        "title": "Duofix süsteemi esiseinapaigaldis massiivse vaheseina ees",
        "wandtypen": [
            "6451219339",
            "6451239051"
        ],
        "produktfamile": [],
        "entWaesserungFallLeitung": [
            "Silent-PP"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6471148171__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix süsteemisein* esiseinana massiivse vaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 30,
        "LAF_DIN_diagonalDarunterliegenderRaum": 29,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 32,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 28,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 27,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 27
    },
    {
        "id": "6459343627",
        "title": "Duofix süsteemi esiseinapaigaldis kipsseina ees",
        "wandtypen": [
            "6451219339",
            "6451221643"
        ],
        "produktfamile": [
            "4948021771"
        ],
        "entWaesserungFallLeitung": [
            "Silent-PP"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6471224459__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix süsteemisein* esiseinana kipsvaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 27,
        "LAF_DIN_diagonalDarunterliegenderRaum": 23,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 28,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 25,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 21,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 21
    },
    {
        "id": "6459325579",
        "title": "Duofix süsteem ruumikõrguse kipsvaheseinana",
        "wandtypen": [
            "6451244811"
        ],
        "produktfamile": [],
        "entWaesserungFallLeitung": [
            "Silent-PP"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6471251851__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix süsteemisein* ruumikõrguse kipsvaheseinana",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 28,
        "LAF_DIN_diagonalDarunterliegenderRaum": 23,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 28,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 26,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 21,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 21
    },
    {
        "id": "6459317771",
        "title": "Duofix element kipsvaheseinas",
        "wandtypen": [
            "6452776331"
        ],
        "produktfamile": [
            "4948021771"
        ],
        "entWaesserungFallLeitung": [
            "Silent-PP"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6472530827__et__Original",
        "imageTitle": "Katsestendi ehitus: Geberit Duofix montaažielemendid ruumikõrguses kipsvaheseinas",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 28,
        "LAF_DIN_diagonalDarunterliegenderRaum": 26,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 29,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 26,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 24,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 24
    },
    {
        "id": "6459398283",
        "title": "Kombifix element massiivses esiseinas massiivse vaheseina ees",
        "wandtypen": [
            "6451218187",
            "6451239051"
        ],
        "produktfamile": [
            "4947988747"
        ],
        "entWaesserungFallLeitung": [
            "Silent-PP"
        ],
        "entWaesserungAnschlussLeitung": [
            "Silent-PP"
        ],
        "filenameWithoutExtension": "6472693003__et__Original",
        "imageTitle": "Geberit Kombifix montaažielement müüritud esiseinas massiivse vaheseina ees",
        "installationsGeraeuscheTableHeading": "Paigaldise müra vastavalt DIN 4109:2016-07, DIN 4109 lisaleht 2:1989-11 ja VDI 4100:2012-10",
        "LAF_DIN_angrenzenderRaum": 38,
        "LAF_DIN_diagonalDarunterliegenderRaum": 30,
        "LAF_VDI_mitGeraeuschenImAngrenzendenRaum": 40,
        "LAF_VDI_ohneGeraeuscheImAngrenzendenRaum": 36,
        "LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum": 30,
        "LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum": 28
    }
];